module.exports = {
          srcSet: "/_next/static/images/img-mobilier@2x-160-524916213c2758d5b0b86430e5a085da.webp"+" 160w"+","+"/_next/static/images/img-mobilier@2x-292-c8315724bf61ada86815774594168a3f.webp"+" 292w",
          images:[ {path: "/_next/static/images/img-mobilier@2x-160-524916213c2758d5b0b86430e5a085da.webp",width: 160,height: 137},{path: "/_next/static/images/img-mobilier@2x-292-c8315724bf61ada86815774594168a3f.webp",width: 292,height: 250}],
          src: "/_next/static/images/img-mobilier@2x-160-524916213c2758d5b0b86430e5a085da.webp",
          toString:function(){return "/_next/static/images/img-mobilier@2x-160-524916213c2758d5b0b86430e5a085da.webp"},
          placeholder: undefined,
          width: 160,
          height: 137
      }